import set from 'lodash/set';
import state from 'store/state/order';
import types from 'store/types/order';

const initialState = state;

export default (state = initialState, action) => {
  const { key, data, error } = action;

  switch (action.type) {
    case types.ORDER_SET:
      set(state, key, data);
      return { ...state };
    default:
      return state;
  }
};
